import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { PlatformService } from '@panamax/app-state';
import {
  getPaymentViewModel,
  isValidTransactionNumber,
} from '@payments/selectors/payments.selector';
import { FileHandlerPaymentsService } from '@payments/services/file-handler-payments.service';
import { InvoiceIsrService } from '@payments/services/invoice-isr.service';
import { PaymentsPaymentService } from '@payments/services/payments-payment.service';
import {
  GetPaymentDetailsResponse,
  PaymentDetailInvoice,
} from '@usf/payment-types';

@Component({
  selector: 'app-payment-details-modal',
  templateUrl: './payment-details-modal.component.html',
  styleUrls: ['./payment-details-modal.component.scss'],
})
export class PaymentDetailsModalComponent {
  @Input() isCancelPayment = true;
  @Input() paymentDetails: GetPaymentDetailsResponse;
  @Input() canCancel: boolean;

  constructor(
    private modalController: ModalController,
    readonly platformService: PlatformService,
    private invoiceIsrService: InvoiceIsrService,
    private fileHandlerService: FileHandlerPaymentsService,
    private paymentsPaymentService: PaymentsPaymentService,
  ) {}

  async closeModal() {
    await this.modalController.dismiss(false);
  }

  async submitCancel() {
    if (!this.isCancelPayment) {
      this.isCancelPayment = true;
      return;
    }
    await this.modalController.dismiss(true);
  }

  formatDate(date: number) {
    return this.paymentsPaymentService.createPaymentPostingDate(date);
  }

  hasSecondaryTransaction(transaction) {
    return (
      isValidTransactionNumber(transaction?.secondaryTransaction) &&
      isValidTransactionNumber(transaction?.originalTransaction)
    );
  }

  get customersSorted() {
    return [...this.paymentDetails.paymentDetails].sort((a, b) => {
      if (!a.userHasAccessToCust && b.userHasAccessToCust) {
        return 1;
      } else if (a.userHasAccessToCust && !b.userHasAccessToCust) {
        return -1;
      } else {
        return a.customerName.localeCompare(b.customerName);
      }
    });
  }

  downloadPaymentDetails() {
    const paymentViewModel = getPaymentViewModel(this.paymentDetails);
    this.fileHandlerService.downloadPaymentActivity([paymentViewModel]);
  }

  printPaymentDetails() {
    const paymentViewModel = getPaymentViewModel(this.paymentDetails);
    this.fileHandlerService.printPaymentDetails(paymentViewModel);
  }

  viewInvoice(transaction: PaymentDetailInvoice) {
    this.invoiceIsrService.viewInvoice(
      transaction.isr.docID.toString(),
      transaction.originalTransaction,
      transaction.secondaryTransaction,
    );
  }
}
